import React, { useEffect } from 'react'

const LogoutComponent: React.FC = () => {
  const styles: React.CSSProperties = {
    position: 'relative',
    top: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }

  useEffect(() => {
    const disableBackNavigation = (event: PopStateEvent) => {
      event.preventDefault()
      window.history.forward()
      return false
    }
    window.history.pushState(null, document.title, window.location.href)
    window.addEventListener('popstate', disableBackNavigation)
    return () => {
      window.removeEventListener('popstate', disableBackNavigation)
    }
  }, [])

  return (
    <div style={styles}>
      <div className="welcome-text">
        Please close the page using browser X and return to the main application.
      </div>
      <div style={{ height: '16px' }} />
      <div className="welcome-text">
        If you need to access reports again, please navigate from the main application.
      </div>
    </div>
  )
}

export default LogoutComponent
